@if (!isLoading) {
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      @if (asideSelfDisplay) {
        @if (asideMenuDynamic) {
          <sc-aside #scAside
            id="sc_aside"
            class="aside aside-left d-flex flex-column flex-row-auto overflow-auto"
            [ngClass]="asideCSSClasses"
          (collapsedAside)="toggleAside()"></sc-aside>
        }
      }
      <!-- end:: Aside Left -->
      <!--begin::Wrapper-->
      <div class="d-flex flex-column flex-row-fluid wrapper" id="sc_wrapper">
        <!-- begin:: Header -->
        <sc-header
          #scHeader
          id="sc_header"
          class="header"
        [ngClass]="headerCSSClasses"></sc-header>
        <!-- end:: Header -->
        <!-- begin:: Content -->
        <div
          class="content d-flex flex-column flex-column-fluid"
          id="sc_content"
          [ngClass]="contentClasses"
          >
          <!-- begin:: Content Body -->
          <router-outlet></router-outlet>
          <!-- end:: Content Body -->
        </div>
        <!-- end:: Content -->
      </div>
    </div>
    <!--end::Page-->
  </div>
}

<!-- start: splash screen -->
@if (isLoading) {
  <div #splashScreen id="splash-screen">
    <img [src]="brandingMedia.SPLASH_LOADER" alt="Loading..." height="92px" />
  </div>
}
<!-- end: splash screen -->